export enum GATEKEEP {
	MUSIC_TOGETHER = 'music_together',
	MUSIC_TOGETHER_CREATE = 'music_together_create',
	MUSIC_TOGETHER_JOIN = 'music_together_join',
	MUSIC_TOGETHER_RELIVE = 'music_together_relive',
}
